import React, { createContext, useContext, useState } from "react";
import { SensorAgent } from "../components/SensorAgent";
import { CbomLibrary } from "@schemas";

interface CbomContextType {
  selectedDeviceId: string;
  setSelectedDeviceId: (id: string) => void;
  showCbomComponent: boolean;
  setShowCbomComponent: (value: boolean) => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;
  showAgentUploadForm: boolean;
  setShowAgentUploadForm: (value: boolean) => void;
  showAgentUpload: boolean;
  setShowAgentUpload: (value: boolean) => void;
  showAddDevice: boolean;
  setShowAddDevice: (value: boolean) => void;
  showAgentViewForm: boolean;
  setShowAgentViewForm: (value: boolean) => void;
  showLibraryViewForm: boolean;
  setShowLibraryViewForm: (value: boolean) => void;
  isAgentUploaded: boolean;
  setIsAgentUploaded: (value: boolean) => void;
  selectedAgent: number;
  selectedLibrary: number;
  setSelectedAgent: (id: number) => void;
  setSelectedLibrary: (id: number) => void;
  selectedAgentData: SensorAgent | null;
  setSelectedAgentData: (data: SensorAgent | null) => void;
  selectedLibraryData: CbomLibrary | null;
  setSelectedLibraryData: (data: CbomLibrary | null) => void;
}

const CbomContext = createContext<CbomContextType | undefined>(undefined);

export const CbomProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedDeviceId, setSelectedDeviceId] = useState<string>("");
  const [showCbomComponent, setShowCbomComponent] = useState<boolean>(false);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [showAgentUploadForm, setShowAgentUploadForm] =
    useState<boolean>(false);
  const [showAgentUpload, setShowAgentUpload] = useState<boolean>(false);
  const [showAddDevice, setShowAddDevice] = useState<boolean>(false);
  const [showAgentViewForm, setShowAgentViewForm] = useState<boolean>(false);
  const [showLibraryViewForm, setShowLibraryViewForm] =
    useState<boolean>(false);
  const [isAgentUploaded, setIsAgentUploaded] = useState<boolean>(false);
  const [selectedLibrary, setSelectedLibrary] = useState<number>(0);
  const [selectedAgent, setSelectedAgent] = useState<number>(0);
  const [selectedAgentData, setSelectedAgentData] =
    useState<SensorAgent | null>(null);
  const [selectedLibraryData, setSelectedLibraryData] =
    useState<CbomLibrary | null>(null);

  return (
    <CbomContext.Provider
      value={{
        selectedDeviceId,
        setSelectedDeviceId,
        showCbomComponent,
        setShowCbomComponent,
        isAuthenticated,
        setIsAuthenticated,
        showAgentUploadForm,
        setShowAgentUploadForm,
        showAgentUpload,
        setShowAgentUpload,
        showAddDevice,
        setShowAddDevice,
        showAgentViewForm,
        setShowAgentViewForm,
        showLibraryViewForm,
        setShowLibraryViewForm,
        isAgentUploaded,
        setIsAgentUploaded,
        selectedAgent,
        setSelectedAgent,
        selectedLibrary,
        setSelectedLibrary,
        selectedAgentData,
        setSelectedAgentData,
        selectedLibraryData,
        setSelectedLibraryData,
      }}
    >
      {children}
    </CbomContext.Provider>
  );
};

export const useCbomContext = (): CbomContextType => {
  const context = useContext(CbomContext);
  if (!context) {
    throw new Error("useCbomContext must be used within a CbomProvider");
  }
  return context;
};
